export type ModalType = "cancel" | "manual" | "invoice" | "convert" | "generate";

interface ModalTextProps {
	title: string;
	confirmTitle: string;
	confirmDescription: string;
	confirmLabel: string;
	cancelLabel: string;
}

export const getModalTexts = (type: ModalType, name: string): ModalTextProps => {
	const baseTexts: Record<ModalType, Omit<ModalTextProps, "cancelLabel">> = {
		cancel: {
			title: `Selecionar parcelas para cancelamento - ${name}`,
			confirmTitle: "Confirmação de Cancelamento",
			confirmDescription: "O cancelamento das parcelas pode afetar o próximo faturamento. Deseja continuar?",
			confirmLabel: "Sim, cancelar",
		},
		manual: {
			title: `Selecionar parcelas para baixa manual - ${name}`,
			confirmTitle: "Confirmação de Baixa Manual",
			confirmDescription: "Esta cobrança será baixada de forma manual. Deseja continuar?",
			confirmLabel: "Sim, baixar",
		},
		invoice: {
			title: `Selecionar cobranças para faturamento - ${name}`,
			confirmTitle: "Confirmação de Faturamento",
			confirmDescription: "O faturamento será convertido em boletos. Deseja continuar?",
			confirmLabel: "Sim, faturar",
		},
		convert: {
			title: `Selecionar cobranças para conversão - ${name}`,
			confirmTitle: "Confirmação de Conversão",
			confirmDescription: "Você está prestes a converter cobranças para outra forma de pagamento. Deseja continuar?",
			confirmLabel: "Sim, converter",
		},
		generate: {
			title: `Selecionar cobranças para geração de boletos - ${name}`,
			confirmTitle: "Confirmação de Geração",
			confirmDescription: "Você está prestes a gerar boletos. Deseja continuar?",
			confirmLabel: "Sim, gerar",
		},
		
	};

	return {
		...baseTexts[type],
		cancelLabel: "Cancelar",
	};
};
